import { render, staticRenderFns } from "./userLicenseManagement.vue?vue&type=template&id=c9863622&scoped=true"
import script from "./userLicenseManagement.vue?vue&type=script&lang=js"
export * from "./userLicenseManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9863622",
  null
  
)

export default component.exports